export default [
  {path: /^\/taxes\/?$/, redirect: () => ({name: 'taxes'})},
  {
    path: /^\/bizs\/\d+\/tax\/?$/,
    redirect: (to) => {
      const {path, query: {'tax-id': taxId}, params} = to
      const [, ,bizId] = path.split('/')
      return {
        name: 'tax-detail',
        params: {
          ...params,
          bizId: String(bizId),
          taxId: String(taxId),
        },
      }
    },
  },
  {path: /^\/invoices\/?$/, redirect: () => ({name: 'received-invoices'})},
  {path: /^\/invoices\/received\/?$/, redirect: () => ({name: 'received-invoices'})},
  {
    path: /^\/bizs\/\d+\/invoice\/?$/,
    redirect: (to) => {
      const {path, query: {'invoice-id': invoiceId}, params} = to
      const [, ,bizId] = path.split('/')
      return {
        name: 'received-invoice-detail',
        params: {
          ...params,
          bizId: String(bizId),
          invoiceId: String(invoiceId),
        },
      }
    },
  },
  {path: /^\/issue\/?$/, redirect: () => ({name: 'issue'})},
  {path: /^\/cert-center\/?$/, redirect: () => ({name: 'cert-center'})},
  {
    path: /^\/link\/?/, 
    redirect: (to) => {
      const {query} = to
      return {
        path: `/bizs/${query.bizs}`,
      }
    }
  }
]
